import { Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { Link, Text, tokens } from '@hotjar/hotsauce';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useHelpHotjarUrl } from '@hotjar/translations';

const StyledText = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x5};
`;

export const SetupWizardHelp = (): JSX.Element => {
  const { click: trackClick } = useTrack();
  const helpHotjarUrl = useHelpHotjarUrl();

  const handleOnClick = () => {
    trackClick('Hotjar documentation', 'Integrate Hotjar Dashboard', {});
  };

  return (
    <StyledText style={{ marginTop: tokens.spacer.x3 }} textType="body2">
      <Trans i18nKey="activation:setup-wizard.help-link">
        Need help?{' '}
        <Link
          kind="standalone"
          onClick={handleOnClick}
          isExternal
          href={`${helpHotjarUrl}/articles/115009336727-Manually-Adding-the-Tracking-Code`}
        >
          Go to Hotjar Documentation
        </Link>
      </Trans>
    </StyledText>
  );
};
